/**
 * Wymiary własne logotypów mediów i wydarzeń.
 * Atrybuty width/height rezerwują miejsce w layoucie (mniejsze CLS,
 * audyt Lighthouse „Elementy graficzne nie mają atrybutów width ani height”).
 * Klucz to nazwa pliku — dopasowujemy ją po fragmencie adresu (CDN i pliki lokalne).
 */
const LOGO_DIMENSIONS: Record<string, [number, number]> = {
  "logo-charaktery": [1024, 1024],
  "logo-cosmopolitan": [1024, 1024],
  "logo-ddtvn": [1024, 1024],
  "logo-dziendobrytvn": [256, 256],
  "logo-elle": [1024, 1024],
  "logo-forbes": [1024, 1024],
  "logo-gazetawyborcza": [1024, 1024],
  "logo-glamour": [1024, 1024],
  "logo-hellozdrowie": [256, 256],
  "logo-natemat": [256, 256],
  "logo-newsweek": [1024, 1024],
  "logo-onet": [256, 256],
  "logo-polki": [256, 256],
  "logo-polsat": [1024, 1024],
  "logo-polskatimes": [1024, 1024],
  "logo-przygodyprzedsiebiorcow": [900, 900],
  "logo-radiozet": [1024, 1024],
  "logo-rzeczpospolita": [256, 256],
  "logo-spotify": [256, 256],
  "logo-tvn24": [1024, 1024],
  "logo-tvp": [256, 256],
  "logo-twojstyl": [1024, 1024],
  "logo-wp": [256, 256],
  "logo-wysokieobcasy": [1024, 1024],
  "logo-zwierciadlo": [1024, 1024],
  "longevity-week": [200, 200],
  "slow-medicine": [270, 270],
  "trojkonferencja": [1020, 660],
  "swieto-kapitalizmu": [512, 512],
};

const FALLBACK: [number, number] = [256, 256];

/** Zwraca wymiary własne logotypu na podstawie adresu obrazka. */
export function logoSize(src?: string): { width: number; height: number } {
  const [width, height] =
    (src && Object.entries(LOGO_DIMENSIONS).find(([key]) => src.includes(key))?.[1]) || FALLBACK;
  return { width, height };
}
